import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export async function bulkMarkAsRead(selectedItems: string[]) {
  const url = occUrl("/notifications/bulkMarkAsRead");

  const response = await occFetch(url, {
    body: JSON.stringify({ ids: selectedItems }),
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
  });

  return await response.json();
}
